import { Icon } from "@ui/Icon";
import askGVTLogoSmall from "@ui/icons/AskGVTLogoSmall.svg?raw";
import gvtStudioLogoSmall from "@ui/icons/GVTStudioLogoSmall.svg?raw";
import { useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { pickerHref } from "@ui/layouts/pickerMode";
import "./PlatformTabs.css";

/** Ask ↔ Studio tabs above the sidebar's main CTA; the active tab opens onto the menu below. */
export const PlatformTabs = () => {
	const isStudio = useLayoutAppKind() === "studio";

	return (
		<div class="platform-tabs">
			<Tab
				href={pickerHref("/", "tabs")}
				mark={askGVTLogoSmall}
				label="Ask"
				name="AskGVT"
				selected={!isStudio}
			/>
			<Tab
				href={pickerHref("/studio", "tabs")}
				mark={gvtStudioLogoSmall}
				label="Studio"
				name="Creator studio"
				selected={isStudio}
			/>
		</div>
	);
};

const Tab = (props: {
	href: string;
	mark: string;
	label: string;
	name: string;
	selected: boolean;
}) => (
	<a
		class="platform-tabs__tab"
		classList={{ "platform-tabs__tab--selected": props.selected }}
		href={props.href}
		aria-label={props.name}
		aria-current={props.selected ? "page" : undefined}
	>
		<Icon
			icon={props.mark}
			fillWithCurrentColor={false}
			class="platform-tabs__mark"
			display="inline-flex"
		/>
		<span class="platform-tabs__label">{props.label}</span>
	</a>
);
